import {
  fetchFoodLiveCategoryUrls,
  validateFoodLiveCategoryUrls,
} from "../../../../api/foodApi";

export const LIVE_URL_REVIEW_STATUS_LABELS = Object.freeze({
  APPROVED_FOR_MANUAL_POC: "Approved for manual PoC",
  NEEDS_REVIEW: "Needs review",
  DO_NOT_USE: "Do not use",
  FIXTURE_ONLY: "Fixture only",
});

export function getLiveUrlReviewStatusClass(reviewStatus) {
  switch (reviewStatus) {
    case "APPROVED_FOR_MANUAL_POC":
      return "status-badge status-badge--success";
    case "NEEDS_REVIEW":
      return "status-badge status-badge--warning";
    case "DO_NOT_USE":
      return "status-badge status-badge--danger";
    default:
      return "status-badge";
  }
}

export function getApprovedLiveCategoryUrls(sourcePayload) {
  return (sourcePayload?.urls || []).filter(
    (entry) => entry.reviewStatus === "APPROVED_FOR_MANUAL_POC"
  );
}

export function isFixtureOnlyLiveCategorySource(sourcePayload) {
  return sourcePayload?.liveCategoryMode === "FIXTURE_ONLY";
}

export function validateSelectedLiveCategoryUrl({
  categoryUrl = "",
  approvedUrls = [],
  sourcePayload = null,
  fixtureOnly = false,
}) {
  const trimmed = String(categoryUrl || "").trim();
  if (!trimmed) {
    return { valid: true, reason: null };
  }

  if (fixtureOnly || isFixtureOnlyLiveCategorySource(sourcePayload)) {
    return {
      valid: false,
      reason: "SOURCE_IS_FIXTURE_ONLY",
      message: "This source is fixture-only. Live category URLs are blocked.",
    };
  }

  const approved = approvedUrls.some((entry) => entry.url === trimmed);
  if (!approved) {
    return {
      valid: false,
      reason: "URL_NOT_APPROVED_FOR_MANUAL_POC",
      message: "Selected URL is not approved for manual PoC ingestion.",
    };
  }

  return { valid: true, reason: null, message: null };
}

export async function loadReviewedLiveCategorySource(sourceKey) {
  const payload = await fetchFoodLiveCategoryUrls({ sourceKey });
  const sourcePayload =
    payload.sources?.find((source) => source.sourceKey === sourceKey) || null;
  return {
    sourcePayload,
    approvedUrls: getApprovedLiveCategoryUrls(sourcePayload),
  };
}

export async function validateLiveCategoryUrlSelection(sourceKey, urls = []) {
  return validateFoodLiveCategoryUrls({ sourceKey, urls });
}
